import React from 'react'

import { TopFilters as TopFiltersWrapper, ExcludedFilterSelect } from '@app/components'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import {
  LOCATION_KEY,
  MONITORINGS_LISTS_KEY,
  MONITORINGS_SUBTYPES_KEY,
  MONITORINGS_TYPES_KEY
} from '@app/constants/queryKeys'

import { getSubtypesTypes, getTypes } from '@app/api/routes/monitorings'
import { getStores } from '@app/api/routes/locationStores'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'
import { getMonitoringListsPromo } from '@app/api/routes/monitoringListsPromo'

import { useFiltersSearch } from '@app/hooks'
import { getFilterFromEntities, getFilterFromEntitiesToLabelsIds } from '@app/utils/entitiesAdapters'

import { commonSelectProps } from './configs'

import type { FiltersParams } from '@app/types/filter'
import type { MonitoringTabTopFiltersProps } from './types'

export const TopFilters: React.FC<MonitoringTabTopFiltersProps> = ({ onSearch, initialFilters }) => {
  const { filters, canResetFilters, setFilters, handleClearFilters, handleSearch } = useFiltersSearch({
    initialFilters,
    onSearch
  })

  const handleExcludedSelectChange = (values: FiltersParams): void => {
    setFilters(prev => ({ ...prev, ...values }))
  }

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.monitoringTypeIds ?? filters.excludedMonitoringTypeIds ?? [] }
        defaultIsExcluded={ !!filters.excludedMonitoringTypeIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.monitoringTypeIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedMonitoringTypeIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
        querySelect={ {
          queryKey: [MONITORINGS_TYPES_KEY.typesItems],
          queryFn: getTypes,
          select: getFilterFromEntities
        } }
      />

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.monitoringSubtypeIds ?? filters.excludedMonitoringSubtypeIds ?? [] }
        defaultIsExcluded={ !!filters.excludedMonitoringSubtypeIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.monitoringSubtypeIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedMonitoringSubtypeIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsSubtypesFilter }
        querySelect={ {
          queryKey: [MONITORINGS_SUBTYPES_KEY.subtypesItems],
          queryFn: getSubtypesTypes,
          select: getFilterFromEntities
        } }
      />

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.storeIds ?? filters.excludedStoreIds ?? [] }
        defaultIsExcluded={ !!filters.excludedStoreIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.storeIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedStoreIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationStoresItems],
          queryFn: getStores,
          select: getFilterFromEntities
        } }
      />

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.clusterIds ?? filters.excludedClusterIds ?? [] }
        defaultIsExcluded={ !!filters.excludedClusterIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.clusterIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedClusterIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      {
        // TODO временно скрываем
        /* <LntSelect
        { ...commonSelectProps }
        value={ filters.clustersGroupIds ?? [] }
        onChange={ value => handleSelectChange('clustersGroupIds', value) }
        placeholder={ FILTERS_PLACEHOLDERS.clusterGroupsFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClusterGroupsItems],
          queryFn: getClusterGroups,
          select: getFilterFromEntities
        } }
        /> */
      }

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.promoIds ?? filters.excludedPromoIds ?? [] }
        defaultIsExcluded={ !!filters.excludedPromoIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.promoIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedPromoIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringListsPromoFilter }
        querySelect={ {
          queryKey: [MONITORINGS_LISTS_KEY.promotion],
          queryFn: getMonitoringListsPromo,
          select: getFilterFromEntitiesToLabelsIds
        } }
      />

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.salesOrganizationIds ?? filters.excludedSalesOrganizationIds ?? [] }
        defaultIsExcluded={ !!filters.excludedSalesOrganizationIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.salesOrganizationIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedSalesOrganizationIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
          queryFn: getSalesOrganization,
          select: getFilterFromEntities
        } }
      />
    </TopFiltersWrapper>
  )
}
